<h1 ev-dialog-title>{{ languageService.languageJSON.TabbedInfoDialog_Legal }}</h1>

<div ev-dialog-content #eulaScrollbar class="scrollable" data-testid="eula-container">
  <div class="privacy-content">
    <app-modal-option-panel>
      <span panel-title>End-User License Agreement</span>
      <div class="eula privacy-policy">
    <h3>End-User License Agreement</h3>

    <p>IMPORTANT, READ CAREFULLY.</p>

    <p>
        1. THIS END-USER LICENSE AGREEMENT (“AGREEMENT”) IS A LEGAL AGREEMENT BETWEEN YOU AND GPS TUNER SYSTEMS KFT.
        (“GPST”) and applies to the use of services, software, on-line or off-line solution and products related to or
        offered on the website <b>evnavigation.com</b>, and includes any accompanying materials and any on-line or
        electronic documentation, whether on this website or linked, or on any other media or in any other form
        (“SERVICE”). This Agreement is a legal and enforceable contract between YOU (“YOU” or “USER”) and GPST.
    </p>

    <p>
        2. BY USING THE SERVICES, YOU AGREE TO BE BOUND BY THE TERMS OF THIS AGREEMENT. IF YOU DO NOT AGREE TO THE TERMS
        OF THIS AGREEMENT, YOU SHALL NOT BE ENTITLED TO USE THE SERVICES.
    </p>

    <p>
        3. The SERVICES are protected by copyright laws and international copyright treaties, as well as other
        intellectual property laws and treaties. The underlying products of the SERVICE is licensed, not sold to YOU.
    </p>

    <p>4. GPST expressly reserves all rights not expressly granted to YOU.</p>

    <p>
        5. Subject to the terms and conditions set out herein, the SERVICE may be used for and related to navigation,
        positioning and orientation together with various abilities, capabilities and adjacent features.
    </p>

    <p>
        6. THE SERVICE LICENSED HEREUNDER MAY CONTAIN DEFECTS. YOU ARE ADVISED NOT TO RELY ON THIS SERVICE TO SAFEGUARD
        IMPORTANT DATA, TO USE CAUTION AND NOT TO RELY IN ANY WAY ON THE CORRECT FUNCTIONING OR PERFORMANCE OF THE
        SERVICE AND/OR ACCOMPANYING MATERIALS.
    </p>

    <p>
        7. The SERVICE is not designed or licensed for use in mission-critical applications, or in hazardous
        environments, requiring fail-safe controls, including without limitation operation of nuclear facilities,
        aircraft navigation or communication systems, air traffic control, or life support or weapons systems.
    </p>

    <p>
        8. YOU should be aware that the SERVICE relies on GPS technology, and is not fail-safe or reliable for
        navigation purposes. YOU should also be aware that the SERVICE uses your data plan and additional costs in
        regard of your internet service may be applicable to third parties. Please consult your internet service
        provider for details.
    </p>

    <p>9. The SERVICE may not be used by any government entity.</p>

    <h3>LICENSE</h3>

    <p>
        10. Under this AGREEMENT, subject to the terms and conditions set out herein, GPST grants to USER a
        non-exclusive, non-transferable license without right of sublicense (“LICENSE”), to use the SOFTWARE,
        provided that the SOFTWARE is combined with a hardware device and is only combined with one hardware device
        at any time.
    </p>

    <p>
        11. The LICENSE applies to any error corrections, updates and upgrades in the SERVICE subsequently provided
        to YOU by GPST, unless such products are provided under different license terms and conditions governing
        their use.
    </p>

    <h3>PERMITTED USE</h3>

    <p>12. The LICENSE permits YOU the use of the SOFTWARE as follows:</p>
    <ul>
        <li> use the SERVICES in relation to the website evnavigation.com.</li>
    </ul>


    <h3>PAYMENTS AND SUBSCRIPTION</h3>

    <p>
        13. YOU may purchase subscriptions to certain item while using the SERVICE. In relation to any such
        subscriptions or any payment made while using the SERVICE the general rules of e-trade as stipulated by
        Hungarian law applies.
    </p>

    <p>
        14. YOU may terminate your subscription in 14 (fourteen) days following payment for any reason in writing
        to GPST's email:
        <a href="mailto:info@gpstuner.com" target="_blank">info&#64;gpstuner.com</a>.
        YOU acknowledge that GPST is entitled to set off from your any payments you made all such fees that have
        already been used by you, including any costs that may have occurred in relation to your order.
    </p>

    <h3>USE RESTRICTIONS</h3>

    <p>
        15. The LICENSE granted under this AGREEMENT is restricted, and YOU are only granted the rights set out
        above. YOU are not permitted to:
    </p>

    <ul>
        <li>download, analyse, modify, translate, adapt, reverse engineer, decompile, disassemble, or otherwise reduce
            the
            SERVICE to a perceivable form;</li>
        <li>create derivative works based on the SERVICE or any part thereof, or attempt to increase the functionality
            of
            the SERVICE in any manner on-line or off-line;</li>
        <li>copy the SERVICE or parts thereof, reproduce through any electronic or mechanical means, and distribute
            copies
            - any unauthorized copying is expressly prohibited;</li>
        <li>rent, lease, resell, or otherwise transfer rights to the SERVICE;</li>
        <li>remove or obscure any copyright or proprietary notices or labels in the SERVICE;</li>
        <li>perform, broadcast, display or present the SERVICE in public.</li>
    </ul>


    <h3>SUPPORT</h3>

    <p>16. YOU hereby acknowledge that GPST is not obliged to provide YOU with any support to this SERVICE.</p>

    <p>
        17. YOU should regularly check <b>www.evnavigation.com</b> for any updates, upgrades, patches or fixes made
        available. GPST shall in no event be responsible for the consequences of YOUR failure to update, upgrade,
        fix or patch the SERVICE.
    </p>

    <h3>COPYRIGHTS</h3>

    <p>
        18. GPST retains the title, ownership rights, intellectual property rights, and trade secrets in and to the
        SERVICE, including all subsequent copies and updates to the SERVICE, regardless of the form or media used.
    </p>

    <h3>THIRD PARTY SOFTWARE</h3>

    <p><strong>19.</strong> The SERVICE uses third party material (software and/or products). The use of third party
        materials included in the SERVICE may be subject to other terms and conditions, including GPL licenses. The
        official copyright notices and specific license conditions of such third party materials are attached to this
        AGREEMENT and/or are accessible at: www.gpstuner.com.</p>

    <p>Please read all third party materials in their entirety. YOU hereby expressly agree to the terms and conditions
        of such third party materials. Should YOU not agree with any of the terms or conditions of such third party
        materials, YOU are not entitled to use the SERVICE. The title, ownership rights, and intellectual property
        rights in and to the content accessed through the SERVICE is the property of the applicable content owner and
        may be protected by applicable copyright or other law. This LICENSE gives YOU no rights to such content.</p>

    <p>All names, brands, trademarks images, and logos identifying third parties and their information, products and
        services are the exclusive property of such third parties. Copying or use of such names, brands, trademarks,
        images and logos is not permitted without the prior approval of the relevant trade mark and/or copyright owner.
    </p>

    <p><strong>a. 7-Zip</strong> - Copyright (C) 2024 Igor Pavlov.</p>
    <p>7-Zip is free software with open source. The most of the code is under the GNU LGPL license. Some parts of the
        code are under the BSD 3-clause License. Also there is unRAR license restriction for some parts of the code.
        <a href="https://www.7-zip.org/license.txt" target="_blank">https://www.7-zip.org/license.txt</a>
    </p>

    <p><strong>b. Freetype</strong> - Portions of this software are copyright © 2011 The FreeType Project
        (<a href="https://www.freetype.org" target="_blank">www.freetype.org</a>). All rights reserved.</p>
    <p><a href="https://gitlab.freedesktop.org/freetype/freetype/-/blob/master/docs/FTL.TXT" target="_blank">
            https://gitlab.freedesktop.org/freetype/freetype/-/blob/master/docs/FTL.TXT</a></p>

    <p><strong>c. libcurl</strong> - Copyright (c) 1996 - 2024, Daniel Stenberg, daniel&#64;haxx.se, and many
        contributors.
        All rights reserved.</p>

    <p>Permission to use, copy, modify, and distribute this software for any purpose with or without fee is hereby
        granted, provided that the above copyright notice and this permission notice appear in all copies.</p>

    <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
        THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT OF THIRD PARTY RIGHTS.
        IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
        IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
        OR OTHER DEALINGS IN THE SOFTWARE.</p>

    <p>Except as contained in this notice, the name of a copyright holder shall not be used in advertising or otherwise
        to promote the sale, use or other dealings in this Software without prior written authorization of the copyright
        holder.</p>

    <p><strong>d. LibGif</strong> - Copyright © 2012 Eric S. Raymond</p>

    <p>Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
        documentation files (the "Software"), to deal in the Software without restriction, including without limitation
        the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
        to permit persons to whom the Software is furnished to do so, subject to the following conditions:</p>

    <p>The above copyright notice and this permission notice shall be included in all copies or substantial portions of
        the Software.</p>

    <p>THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
        THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
        AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
        CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
        DEALINGS IN THE SOFTWARE.</p>

    <p><strong>e. Libjpeg</strong> - Copyright (C) 1991-2024, Thomas G. Lane, Guido Vollbeding. All Rights Reserved
        except as specified below.</p>

    <p>This software is based in part on the work of the Independent JPEG Group</p>

    <p><strong>f. Libjpeg2000</strong> - The copyright in this software is being made available under the 2-clauses BSD
        License, included below. This software may be subject to other third party and contributor rights, including
        patent rights, and no such rights are granted under this license.</p>

    <p>Copyright (c) 2002-2014, Universite catholique de Louvain (UCL), Belgium<br>
        Copyright (c) 2002-2014, Professor Benoit Macq<br>
        Copyright (c) 2003-2014, Antonin Descampe<br>
        Copyright (c) 2003-2009, Francois-Olivier Devaux<br>
        Copyright (c) 2005, Herve Drolon, FreeImage Team<br>
        Copyright (c) 2002-2003, Yannick Verschueren<br>
        Copyright (c) 2001-2003, David Janssens<br>
        Copyright (c) 2011-2012, Centre National d'Etudes Spatiales (CNES), France<br>
        Copyright (c) 2012, CS Systemes d'Information, France</p>

    <p>All rights reserved.</p>

    <p>Redistribution and use in source and binary forms, with or without modification, are permitted provided that the
        following conditions are met:</p>

    <p>1. Redistributions of source code must retain the above copyright notice, this list of conditions and the
        following disclaimer.<br>
        2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the
        following disclaimer in the documentation and/or other materials provided with the distribution.</p>

    <p>THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED
        WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
        PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
        DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
        PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
        CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
        OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
        DAMAGE.</p>

    <p><strong>g. libpng</strong> - Copyright (c) 2000-2002, 2004, 2006-2018 Glenn Randers-Pehrson</p>

    <p><strong>h. OpenSSL</strong> - Copyright (c) 1998-2024 The OpenSSL Project Authors, Copyright (c) 1995-1998 Eric
        A. Young, Tim J. Hudson - All rights reserved.</p>
    <p>Apache License, Version 2.0 <a href="http://www.apache.org/licenses/LICENSE-2.0"
            target="_blank">http://www.apache.org/licenses/LICENSE-2.0</a></p>

    <p><strong>i. Zlib</strong> - © 1995-2024 Jean-loup Gailly and Mark Adler.</p>

    <p>While maintaining evnavigation.com GPS Tuner Systems Kft. is committed to provide the highest possible level of
        service. In order to do that GPS Tuner Systems Kft. is using the following third party sources and applications:
    </p>

    <p><strong>j. Maps and charging stations:</strong></p>

    <p>(c) OpenStreetMap contributors<br>
        OSM data is available under the Open Database Licence<br>
        <a href="https://www.openstreetmap.org/copyright" target="_blank">https://www.openstreetmap.org/copyright</a></p>

    <p>(c) Openchargemap<br>
        Licensed under licensed under Creative Commons Attribution 4.0 International (CC BY 4.0)
        <a href="https://creativecommons.org/licenses/by-sa/4.0/"
            target="_blank">https://creativecommons.org/licenses/by-sa/4.0/</a><br>
        <a href="https://openchargemap.org/site/about/terms"
            target="_blank">https://openchargemap.org/site/about/terms</a>
    </p>

    <p><strong>k. Weather data provided by OpenWeather</strong> - <a href="https://openweathermap.org"
            target="_blank">https://openweathermap.org</a></p>

    <p><strong>l. For the User Interface and the Backend used by the evnavigation.com website, please, check </strong>
        <a href="https://evnavigation.com/3rdpartylicenses.txt"
            target="_blank">https://evnavigation.com/3rdpartylicenses.txt</a>
    </p>

    <h3>DISCLAIMER, LIMITATION OF LIABILITY</h3>

    <p><strong>20.</strong> GPST does not represent or warrant that the SERVICE operates correctly and error-free. To
        the maximum extent permitted by applicable law, GPST provides YOU with the SERVICE “AS IS AND WITH ALL FAULTS”,
        and hereby disclaim any warranty, express or implied (either in fact or by operation of law), with respect to
        the SERVICE, either as to merchantability, fitness for particular purpose, or any other matter which are
        expressly excluded. USER acknowledges and agrees that the SERVICE has not been tested or certified by any
        government agency or industry regulatory organization or any other third party organization. In no event shall
        GPST be held liable for, liabilities or obligations for damages, including but not limited to special, indirect,
        or consequential damages or loss of use, revenue, or profits in connection with or arising out of this AGREEMENT
        or any breach of this AGREEMENT by GPST or the existence, furnishing, functioning, or any use of the SERVICE.
        GPST’s sole liability of any kind, including negligence, with respect to the SERVICE, whether the claimed
        liability is based on a defect, either discoverable or latent, in the SERVICE, shall be limited to the remedies
        provided in this AGREEMENT. Any other representations or warranties made by any person, including employees or
        representatives of GPST, which are inconsistent herewith shall be disregarded by USER and shall not be binding
        upon GPST. NO ORAL OR WRITTEN ADVICE OR INFORMATION PROVIDED BY GPST OR ON ITS BEHALF SHALL CREATE A WARRANTY OR
        IN ANY WAY INCREASE THE SCOPE OF THIS LIMITED WARRANTY, AND USER IS NOT ENTITLED TO RELY ON ANY SUCH ADVICE OR
        INFORMATION.</p>

    <p><strong>21.</strong> Any liability of GPST towards USER shall be void if any damage to SERVICE is caused by
        accident, neglect or misuse, alteration (which shall include, but not be limited to, any deviation from the
        specifications), any unauthorized modification or enhancement of the SERVICE, or the use of the SERVICE for
        other than the specific purpose for which it was designed.</p>

    <p><strong>22.</strong> In no event shall GPST be liable for any third party materials, database and/or their
        content, including all implications arising from such error or malfunction related to database.</p>

    <p><strong>23.</strong> Provision of the SERVICE under this AGREEMENT shall not create any obligation for GPST to
        continue to develop, productize, support, repair, offer for sale or in any other way continue to provide or
        develop the SERVICE either to YOU or to any other party.</p>

    <h3>TERMINATION</h3>

    <p><strong>24.</strong> GPST shall be entitled to terminate this AGREEMENT with immediate effect if YOU fail to
        comply with any of its terms and conditions. The provisions of this AGREEMENT in relation to confidential
        information, disclaimer of warranties, limitation of liabilities, copyrights and rights in intellectual property
        shall survive any termination. GPST reserves the right to discontinue any of its services under or in connection
        with this AGREEMENT.</p>

    <h3>CONFIDENTIAL INFORMATION</h3>

    <p><strong>25.</strong> USER shall hold in confidence all confidential information disclosed to USER in connection
        with this AGREEMENT, including, without limitation, information concerning the SERVICE, GPST, any legal,
        financial and technical information, and any information which can be obtained by examination, testing or
        analysis of the SERVICE. USER shall use reasonable diligence in order to prevent the unauthorized disclosure or
        reproduction of such information.</p>

    <h3>PRIVACY</h3>

    <p><strong>26.</strong> YOU hereby grant YOUR consent to the use of YOUR personal details, personally identifiable
        data by GPST to the following extent:</p>

    <p>a. YOU expressly agree and authorize GPST to collect and use your following personal data in order to provide you
        the SERVICE: your name, your email address, your postal address, your phone number, your profile picture, any
        track data related to you or your use of your vehicle;</p>

    <p>b. GPST and its affiliates may collect and use technical information gathered as part of any services provided to
        YOU, related to the AGREEMENT or the implementation of the SERVICE. GPST and its affiliates may use this
        information to improve products, to provide customized services or technologies to YOU or to anonymize the data
        collected via YOUR usage of the service and to make reports based on such anonymous data and provide it to third
        parties or otherwise commercialize it. In any event GPST will not disclose any information in a form that
        personally identifies YOU without your prior consent;</p>

    <p>c. unless agreed otherwise, the personally identifiable information provided by YOU to GPST will not be used but
        for purposes of copyright protection;</p>

    <p>d. if YOU expressly agree, GPST and its partners may deliver to YOU highly relevant commercial offers in many
        ways including but not limited to the following: products and services of GPST and its commercial partners;</p>

    <p>e. if YOU expressly agree, GPST and its partners may use your personally identifiable information provided by YOU
        to increase user experience and to provide elevated services and functions to the SERVICE.</p>

    <h3>MISCELLANEOUS PROVISIONS</h3>

    <p><strong>27.</strong> YOU expressly acknowledge that YOU are not entitled to transfer, export or re-export the
        SERVICE to any country, person, or entity (including, but not limited to Cuba, Iran, Libya, North Korea, Sudan
        and Syria, or to any national or citizen of any such country, wherever located, who intends to transmit or
        transport the SERVICE to such country) subject to embargo or export restrictions of either the European Union or
        the United States of America. For further information in relation to this restriction, please seek advice from
        the relevant governmental agencies of the European Union or the United States of America. Additional information
        can be found at <a href="http://ec.europa.eu/" target="_blank">http://ec.europa.eu/</a> and <a
            href="http://www.bis.doc.gov/" target="_blank">http://www.bis.doc.gov/</a> .</p>

    <p><strong>28.</strong> YOU agree that YOU will not use the SERVICE for any purposes prohibited by law.</p>

    <p><strong>29.</strong> This LICENSE and AGREEMENT may be subject to the statutory laws in YOUR jurisdiction, and
        shall be applicable to the extent as permitted by such laws. In any jurisdiction that have implemented the EEC
        Software Directive, the restrictions and terms of this LICENSE are subject to such exceptions as may be required
        by local law.</p>

    <p><strong>30.</strong> This AGREEMENT (including any addendum or amendment) and any other terms and conditions, if
        applicable, is the entire agreement between YOU and GPST. This AGREEMENT supersedes all prior or contemporary
        oral or written communication, offers, declarations and representations in relation to the SERVICE. Should any
        part or provision of this AGREEMENT qualify as invalid, void, not enforceable or against statutory laws in the
        relevant jurisdiction, such fact shall not have any effect on any other part or provision of this AGREEMENT,
        which shall continue with unchanged force and effect and the invalid, void, not enforceable or unlawful
        provision shall be interpreted so as to best accomplish the objectives thereof within the limits of applicable
        law. The English version of this AGREEMENT is the governing language version, and any translations thereof are
        provided to YOU for YOUR convenience only. This AGREEMENT and any disputes arising out of or in connection with
        this AGREEMENT and/or the SERVICE shall be governed by the Hungarian law, and shall be resolved by the competent
        Courts of Hungary. The failure of GPST to exercise or enforce any right or provision of this Agreement shall not
        constitute a waiver of such right or provision.</p>

    <p><strong>31.</strong> Should YOU have any questions in relation to this AGREEMENT, please contact GPST at the
        e-mail address as follows: <a href="mailto:legal@gpstuner.com">legal&#64;gpstuner.com</a></p>

    <p>Copyright © 2020-2026 GPS Tuner Systems Kft. GPS Tuner and GPS Share are registered trademarks and/or brands of GPS
        Tuner Systems Kft. All rights reserved.<br>
        <a href="mailto:info@gpstuner.com">info&#64;gpstuner.com</a>
    </p>
</div>
    </app-modal-option-panel>
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" name="ok_button" mat-button (click)="dialogRef?.close()" data-testid="eula-close-btn">
    {{ languageService.languageJSON.Global_Close }}
  </button>
</div>